import { Themes } from "./types";

const themes: Themes = {
  main: {
    walix: "#FE8800",
    titles: "#272B34",
    text: "#52555D",
    lightText: "#B9B7BD",
    primaryButtonGradient: "linear-gradient(134.28deg, #ff8900 0.75%, #ff5c00 174.17%)",
    featureBackground: "#EFEFEF",
    background: "#FBFBFB",
  },
};

export default themes;
